import { MessageCircle, Phone } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { buildSms, telHref } from "@/lib/sms";
import { useLang } from "@/contexts/LangContext";

export const StickyBar = () => {
  const { t } = useLang();
  return (
    <div
      data-testid={HOME.stickyBar}
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-black/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center gap-2 px-4 py-3 sm:px-8">
        <div className="hidden sm:flex flex-col mr-auto">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#00ff41]">
            OSS · 24/7
          </span>
          <span className="font-display text-sm font-semibold text-white">
            {t("ottawa_gatineau_delivery")}
          </span>
        </div>
        <a
          data-testid={HOME.stickyCallBtn}
          href={telHref()}
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2.5 text-sm font-display font-semibold text-white hover:bg-white/10 transition"
        >
          <Phone size={14} />
          {t("call")}
        </a>
        <a
          data-testid={HOME.stickyTextBtn}
          href={buildSms({ categoryId: "sticky" })}
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-[#00ff41] px-5 py-2.5 text-sm font-display font-bold text-black hover:bg-[#00e63a] transition"
        >
          <MessageCircle size={14} />
          {t("text_to_order")}
        </a>
      </div>
    </div>
  );
};

export default StickyBar;
